module.exports = __webpack_public_path__ + "static/media/insta.7240e34c.svg";